import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-24 bg-[#1A2B4A]">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <p className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4">
          Passons à l'action
        </p>
        <h2 className="font-poppins text-3xl lg:text-4xl font-semibold text-white mb-6">
          Prêt à développer votre activité ?
        </h2>
        <p className="text-gray-300 text-sm leading-relaxed mb-10 max-w-lg mx-auto">
          Contactez-nous pour échanger sur vos besoins. Nous vous proposons des
          solutions claires et adaptées à votre situation.
        </p>
        <Link
          to="/contact"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white text-[#1A2B4A] font-medium text-sm hover:bg-gray-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-mail-line"></i>
          Contactez-nous
        </Link>
      </div>
    </section>
  );
}
